export const getOtherParticipant = (conversation, currentUserId) => {
  if (!conversation) return null;
  if (['direct', 'support'].includes(conversation.conversation_type)) {
    return conversation.participant_details?.find(p => p.user_id !== currentUserId);
  }
  return null;
};

export const getConversationName = (conversation, currentUserId) => {
  if (!conversation) return 'Unknown';
  
  if (conversation.conversation_type === 'group') {
    return conversation.name || 'Group Chat';
  }
  
  if (conversation.conversation_type === 'support') {
    if (conversation.customer_name) {
      return `Support: ${conversation.customer_name}`;
    }
    const customer = conversation.participant_details?.find(p => p.role === 'customer');
    if (customer?.name) {
      return `Support: ${customer.name}`;
    }
  }
  
  const other = getOtherParticipant(conversation, currentUserId);
  return other?.name || 'Unknown';
};

// Mongo datetimes are serialised as naive UTC ("2026-09-10T16:01:00.123") — without this a UK/NG phone shows UTC instead of local time.
export const parseServerDate = (v) => {
  if (v instanceof Date) return v;
  if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(v) && !/(Z|[+-]\d{2}:?\d{2})$/.test(v)) return new Date(`${v}Z`);
  return new Date(v);
};

export const formatTime = (timestamp) => {
  if (!timestamp) return '';
  const date = parseServerDate(timestamp);
  const now = new Date();
  const diffMs = now - date;
  const diffDays = Math.floor(diffMs / 86400000);

  const timeStr = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  if (diffDays === 0) return timeStr;
  if (diffDays === 1) return `Yesterday ${timeStr}`;
  if (diffDays < 7) return `${date.toLocaleDateString([], { weekday: 'short' })} ${timeStr}`;
  return `${date.toLocaleDateString([], { month: 'short', day: 'numeric' })} ${timeStr}`;
};

export const getInitials = (name) => {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};
